import { useCallback, useEffect, useState } from 'react';

interface IUseResponsiveSize {
    height: number;
    width: number;
}

export const useResponsiveSize = (): IUseResponsiveSize => {
    const [width, setWidth] = useState<number>(0);
    const [height, setHeight] = useState<number>(0);

    const setSizes = useCallback(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }, [setWidth, setHeight]);

    useEffect(() => {
        window.addEventListener('resize', setSizes);
        setSizes();

        return () => window.removeEventListener('resize', setSizes);
    }, [setSizes]);

    return { width, height };
};
